<!--
 * @Description: 活码扫码页面
 * @Author: mdb
 * @Date: 2022-07-26 16:36:00
 * @LastEditTime: 2023-04-20 13:54:11
 * @LastEditors: mdb
-->
<template>
  <div class="mobile-container" :class="{ 'has-tips': !isFormPage }">
    <div class="loading-container" v-if="loadingPage"><a-spin /></div>

    <template v-if="isFormPage">
      <div class="picture" @click="handleExpand('img')">
        <img :src="templateData.background" />
      </div>
      <div class="form-content" :class="{ 'is-expand': isExpand }" @click="handleExpand('form')">
        <a-form ref="formRef" :colon="false" labelAlign="left" :model="dataForm" autocomplete="off">
          <template v-for="(item, index) in previewForm" :key="index">
            <!-- 客户名称 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              name="customerName"
              :label="item.label"
              v-if="item.field === 'customerName'"
            >
              <a-input
                v-model:value.trim="dataForm.customerName"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 客户办公地 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              name="customerOffice"
              :label="item.label"
              v-if="item.field === 'customerOffice'"
            >
              <CustomerArea
                v-model:value="dataForm.customerOffice"
                change-on-select
                allowClear
                :placeholder="`请选择${item.label}`"
              />
            </a-form-item>
            <!-- 客户类型 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              name="customerType"
              :label="item.label"
              v-if="item.field === 'customerType'"
            >
              <a-select
                v-model:value="dataForm.customerType"
                :options="customSelectOption(customerTypeEnum, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
              />
            </a-form-item>
            <!-- 标签 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              name="customerTag"
              :label="item.label"
              v-if="item.field === 'customerTag'"
            >
              <a-select
                v-model:value="dataForm.customerTag"
                :options="customSelectOption(tagListEnum, item.checked)"
                mode="multiple"
                allowClear
                :placeholder="`请选择${item.label}`"
                :fieldNames="{ label: 'name', value: 'name' }"
              />
            </a-form-item>
            <!-- 备注 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              name="remark"
              :label="item.label"
              v-if="item.field === 'remark'"
            >
              <a-textarea
                v-model:value="dataForm.remark"
                :maxlength="2000"
                :placeholder="`请输入${item.label}`"
                :rows="2"
              />
            </a-form-item>
            <!-- 联系人名称 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'name']"
              :label="item.label"
              v-if="item.field === 'contact.name'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.name"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 性别 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['contact', 'sex']"
              :label="item.label"
              v-if="item.field === 'contact.sex'"
            >
              <a-select
                v-model:value="dataForm.contact.sex"
                :options="customSelectOption(genderEnum, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
              />
            </a-form-item>
            <!-- 角色 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['contact', 'jobRole']"
              :label="item.label"
              v-if="item.field === 'contact.jobRole'"
            >
              <a-select
                v-model:value="dataForm.contact.jobRole"
                :options="customSelectOption(linkRoleTypeEnum, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
              />
            </a-form-item>
            <!-- 联系方式 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'mobile']"
              :label="item.label"
              v-if="item.field === 'contact.mobile'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.mobile"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'email']"
              :label="item.label"
              v-if="item.field === 'contact.email'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.email"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'wechat']"
              :label="item.label"
              v-if="item.field === 'contact.wechat'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.wechat"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'qq']"
              :label="item.label"
              v-if="item.field === 'contact.qq'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.qq"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'tel']"
              :label="item.label"
              v-if="item.field === 'contact.tel'"
            >
              <a-input
                v-model:value.trim="dataForm.contact.tel"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 联系人备注 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['contact', 'remark']"
              :label="item.label"
              v-if="item.field === 'contact.remark'"
            >
              <a-textarea
                v-model:value="dataForm.contact.remark"
                :maxlength="2000"
                :placeholder="`请输入${item.label}`"
                :rows="2"
              />
            </a-form-item>
            <!-- 产品货型 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'cargoType']"
              :label="item.label"
              v-if="item.field === 'business.cargoType'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.cargoType"
                :options="customSelectOption(paramCodeData.zbu_product_type, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
            <!-- 销售平台 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'salePlatform']"
              :label="item.label"
              v-if="item.field === 'business.salePlatform'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.salePlatform"
                :options="customSelectOption(paramCodeData.zbu_channel_detail, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
            <!-- 需求海外仓 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'warehouse']"
              :label="item.label"
              v-if="item.field === 'business.warehouse'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.warehouse"
                :options="customSelectOption(paramCodeData.zbu_demand_info, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
            <!-- 发货地 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['business', 'shipAddress']"
              :label="item.label"
              v-if="item.field === 'business.shipAddress'"
            >
              <a-input
                v-model:value.trim="dataForm.business.shipAddress"
                :maxlength="200"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 销售品类 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['business', 'salesCategory']"
              :label="item.label"
              v-if="item.field === 'business.salesCategory'"
            >
              <a-input
                v-model:value.trim="dataForm.business.salesCategory"
                :maxlength="200"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 跨境月销售额 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'monthSales']"
              :label="item.label"
              v-if="item.field === 'business.monthSales'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.monthSales"
                :options="customSelectOption(paramCodeData.zbu_monthly_sales, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
            <!-- 目的国家 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['business', 'destinationCountry']"
              :label="item.label"
              v-if="item.field === 'business.destinationCountry'"
            >
              <a-input
                v-model:value.trim="dataForm.business.destinationCountry"
                :maxlength="100"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 需要的服务 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请输入${item.label}` }]"
              :name="['business', 'requiredServices']"
              :label="item.label"
              v-if="item.field === 'business.requiredServices'"
            >
              <a-input
                v-model:value.trim="dataForm.business.requiredServices"
                :maxlength="200"
                allowClear
                :placeholder="`请输入${item.label}`"
              />
            </a-form-item>
            <!-- 服务需求 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'serviceNeeds']"
              :label="item.label"
              v-if="item.field === 'business.serviceNeeds'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.serviceNeeds"
                :options="customSelectOption(paramCodeData.zbu_service_demand, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
            <!-- 是否已有合作 -->
            <a-form-item
              :rules="[{ required: item.required, message: `请选择${item.label}` }]"
              :name="['business', 'cooperation']"
              :label="item.label"
              v-if="item.field === 'business.cooperation'"
            >
              <ParamCodesSelect
                v-model:value="dataForm.business.cooperation"
                :options="customSelectOption(paramCodeData.zbu_existing_cooperation, item.checked)"
                allowClear
                :placeholder="`请选择${item.label}`"
                mode="multiple"
              />
            </a-form-item>
          </template>
        </a-form>
      </div>
      <div class="btn-footer">
        <a-button type="primary" block size="large" :loading="loading" @click="submit()">提交</a-button>
        <!-- <a-checkbox v-model:checked="isAgreeChecked"
        >我已经阅读并同意<a @click.stop.prevent="showModal">隐私协议</a></a-checkbox
      > -->
      </div>
    </template>

    <template v-if="finishPage || successPage">
      <template v-if="successImages.length">
        <img class="success-images" v-for="(img, index) in successImages" :key="index" :src="img" />
      </template>
      <template v-else>
        <div class="tips-content">
          <img src="@/assets/marketing/mobile-tips.svg" />
          <p class="tips-content_title" v-if="successPage">提交成功！</p>
          <p class="tips-content_subtitle" v-if="successPage">稍后会有顾问与您联系</p>
          <p class="tips-content_subtitle" v-if="finishPage">活动已结束，感谢您的关注</p>
          <a-button type="primary" shape="round" size="large" :loading="loading" @click="handleCancel()">关闭</a-button>
        </div>
      </template>
    </template>
  </div>

  <!-- <a-modal v-model:visible="visible" title="隐私协议" width="100%" wrap-class-name="full-modal" @ok="handleOk">
    <p>等产品找法务提供相关隐私协议</p>
  </a-modal> -->
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useTitle } from '@vueuse/core'
import CustomerArea from '@/components/CustomerArea/index'
import { customerTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/marketing/commonEnum/dataConfig'
import templateFields from '@/utils/templateFields'
import { templateDetail, clueActivityAdd, activityDetail } from '@/api/marketing/marketingManage'
import { useEnum } from './components/useEnum'
import type { FormInstance } from 'ant-design-vue'
const route = useRoute()
const title = useTitle()
const { paramCodeData, tagListEnum, getByParamCodes, getTagList } = useEnum()

interface TemplateData {
  background?: string
  config?: any[]
  globalConfig?: any
}
interface TemplateForm {
  customerName?: string
  channel?: number
  customerOffice?: string
  customerType?: number
  customerTag?: string
  remark?: string
  contact: {
    name?: string
    sex?: number
    jobRole?: number
    mobile?: string
    email?: string
    wechat?: string
    qq?: string
    tel?: string
    remark?: string
  }
  business: {
    cargoType?: number
    salePlatform?: number
    warehouse?: number
    shipAddress?: string
    salesCategory?: string
    monthSales?: number
    destinationCountry?: string
    requiredServices?: string
    serviceNeeds?: number
    cooperation?: number
  }
}

const loadingPage = ref(false) // 页面加载动画
const finishPage = ref(false) // 活动是否已经结束
const isFormPage = ref(false) // 是否是表单页面
const successPage = ref(false) // 是否提交成功页面
const getActivityDetails = (): Promise<boolean> => {
  loadingPage.value = true
  return new Promise((resolve, reject) => {
    activityDetail({ activityQrcodeId: qrcodeId.value })
      .then(({ data }) => {
        if (data == null) return resolve(false)
        title.value = data.activityName
        const curTime = new Date().getTime()
        const endTime = new Date(data.endTime).getTime()
        if (!data.enableFlag || curTime > endTime) {
          // 活动已结束
          isFormPage.value = false
          finishPage.value = true
          resolve(false)
        } else {
          isFormPage.value = true
          resolve(true)
        }
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        loadingPage.value = false
      })
  })
}

const fieldsFlatAll = templateFields.reduce((arr: any, item) => {
  arr = [...arr, ...item.options]
  return arr
}, [])
const previewForm = ref<any[]>([])

// const isAgreeChecked = ref(false)
const dataForm: TemplateForm = reactive({ contact: {}, business: {} })
const qrcodeId = computed(() => route.query.qrcodeId as string)
const templateId = computed(() => parseInt(route.query.templateId as string))
const templateData: TemplateData = reactive({})
const successImages = computed(() => {
  return templateData.globalConfig?.successImages.map((item: any) => item.url) || []
})
const getTemplateDetail = () => {
  templateDetail({ templateId: templateId.value }).then((res) => {
    res.data.config = JSON.parse(res.data.config as string)
    res.data.globalConfig = JSON.parse(res.data.globalConfig as string)
    Object.assign(templateData, res.data)

    const list = templateData.config?.map((item) => {
      const fieldItem = fieldsFlatAll.find((e: any) => e.field === item.field)
      return Object.assign({}, fieldItem, {
        label: item.label || fieldItem?.label || '',
        required: item.required,
        checked: toRaw(item.checked) || undefined
      })
    })
    previewForm.value = list || []
  })
}
onBeforeMount(async () => {
  const flag = await getActivityDetails()
  if (!flag) return
  await getTagList()
  await getByParamCodes('fbu')
  getTemplateDetail()
})

const isExpand = ref<boolean>(false)
const handleExpand = (type: 'img' | 'form') => {
  if (type === 'img' && isExpand.value) isExpand.value = false
  if (type === 'form' && !isExpand.value) isExpand.value = true
}

// const visible = ref<boolean>(false)
// const showModal = () => {
//   visible.value = true
// }
// const handleOk = (e: MouseEvent) => {
//   console.log(e)
//   isAgreeChecked.value = true
//   visible.value = false
// }

const loading = ref(false)
const formRef = ref<FormInstance>()
const submit = async () => {
  // if (!isAgreeChecked.value) {
  //   return message.warning('请先阅读并同意隐私协议')
  // }
  try {
    const values = await formRef.value?.validateFields()
    const params = Object.assign({}, toRaw(values), {
      activityQrcodeId: qrcodeId.value
    })
    loading.value = true
    clueActivityAdd(params)
      .then(() => {
        // 提交成功
        isFormPage.value = false
        successPage.value = true
      })
      .finally(() => {
        loading.value = false
      })
  } catch (errorInfo) {
    console.log('Failed:', errorInfo)
  }
}
const handleCancel = () => {
  window.close()
}

// 过滤下拉框选项
const customSelectOption = (oldList: any[], newList?: number[] | string[]) => {
  if (oldList == null) return []
  if (newList == null || newList.length === 0) return oldList || []
  const list = newList.map((item) => {
    const find = oldList.find((e: any) => e.id === item || e.value === item)
    return toRaw(find)
  })
  return list.filter((e) => e != null) || []
}
</script>
<script lang="ts">
export default { name: 'DcCosZbuQrcodeMobile' }
</script>

<style lang="scss" scoped>
.mobile-container {
  display: flex;
  height: 100%;
  flex-direction: column;

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: aliceblue;
  }

  .picture {
    flex: 1;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .form-content {
    height: 12%;
    max-height: 66%;
    padding: 16px 16px 0;
    background-color: #ffffff;
    overflow-y: auto;
    transition: all 0.3s linear;
    will-change: height;
    &.is-expand {
      height: 50%;
    }

    :deep(.ant-form-item) {
      display: flex;
      margin-bottom: 16px;
      line-height: 2;
      .ant-form-item-label {
        width: 100px;
      }
    }
  }
  .btn-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 14%;
    padding: 0 16px;
    :deep(.ant-btn) {
      height: 40px;
      &.ant-btn-lg {
        font-size: 14px;
      }
    }
    :deep(.ant-checkbox-wrapper) {
      margin-top: 2%;
      color: #999999;
      &.ant-checkbox-wrapper-checked {
        color: #132043;
        .ant-checkbox-inner {
          background-color: #132043;
          border-color: #132043;
        }
      }
      .ant-checkbox {
        top: 0.18em;
      }
    }
  }

  &.has-tips {
    flex-direction: row;
    align-items: center;
  }
  .success-images {
    width: 100%;
  }
  .tips-content {
    flex: 1;
    text-align: center;
    .tips-content_title {
      font-size: 15px;
      font-weight: 500;
    }
    .tips-content_subtitle {
      margin: 12px 0 80px;
      font-size: 15px;
      font-weight: 400;
    }
    :deep(.ant-btn) {
      width: 170px;
    }
  }
}
</style>
